import Vue from 'vue';
export const LoadingIndicator = Vue.extend({
    functional: true,
    name: 'LoadingIndicator',
    props: {
        classPostfix: String,
    },
    render(createElement, ctx) {
        return (<svg class={`loading-indicator ${ctx.props.classPostfix || ''}`} viewBox="0 0 50 50">
                <circle class="loading-indicator__ring" cx="25" cy="25" r="20"/>
                <circle class="loading-indicator__ball" cx="25" cy="5" r="3.5"/>
            </svg>);
    },
});
//# sourceMappingURL=LoadingIndicator.jsx.map